import { render, staticRenderFns } from "./DiagramAnswerTool.vue?vue&type=template&id=4a99fc5e"
import script from "./DiagramAnswerTool.vue?vue&type=script&lang=js"
export * from "./DiagramAnswerTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports